import React from 'react';
const MessageSquareDotIcon = (props: React.SVGProps<SVGSVGElement>) =>
(
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"
    {...props} >
    <path d="M17.5 12.5C17.5 12.942 17.3244 13.366 17.0118 13.6785C16.6993 13.9911 16.2754 14.1667 15.8333 14.1667H5.83333L2.5 17.5V4.16667C2.5 3.72464 2.67559 3.30072 2.98816 2.98816C3.30072 2.67559 3.72464 2.5 4.16667 2.5H15.8333C16.2754 2.5 16.6993 2.67559 17.0118 2.98816C17.3244 3.30072 17.5 3.72464 17.5 4.16667V12.5Z"
      stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    <circle cx="6.25065" cy="8.54167" r="1.04167" fill="currentColor" />
    <circle cx="10.0007" cy="8.54167" r="1.04167" fill="currentColor" />
    <circle cx="13.7507" cy="8.54167" r="1.04167" fill="currentColor" />
  </svg>
);


export default MessageSquareDotIcon;